import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  Renderer2,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {
  RegistrationService
} from "@aparraga/ahoracrypto-client-common/src/app/common/registration/registration.service";
import {AccountService} from "@aparraga/ahoracrypto-client-common/src/app/common/account/account.service";
import {Subscription} from "rxjs";
import {ExchangeService} from "@aparraga/ahoracrypto-client-common/src/app/common/exchange/exchange.service";
import {
  PurchaseFlowHelperService
} from "@aparraga/ahoracrypto-client-common/src/app/common/flowhelpers/purchaseflowhelper.service";
import {ProductService} from "@aparraga/ahoracrypto-client-common/src/app/common/product/product.service";
import {ScrollService} from "../../shared/scroll/scroll.service";
import {SelectCrypto2Component} from "../../shared/parts/selectcrypto2/selectcrypto2.component";
import {NavbarService} from "../../shared/decorators/navbar/navbar.service";
import {Title} from "@angular/platform-browser";
import {FlowService} from "../../shared/flow/flow.service";
import {NavigationService} from "@aparraga/ahoracrypto-client-common/src/app/common/navigation/navigation.service";
import {CacheService} from "@aparraga/ahoracrypto-client-common/src/app/common/cache/cache.service";
import {ContentControllerService} from "@aparraga/ahoracrypto-api-sdk/sdk/api/contentController.service";
import {DOCUMENT} from "@angular/common";
import {ENVIRONMENT, IS_BROWSER} from "@aparraga/ahoracrypto-client-common/src/app/common/utils/injectiontokens";
import {ActivatedRoute} from "@angular/router";
import {CryptoForm1Component} from "../../shared/webflow/cryptoform1/cryptoform1.component";
import {GlightboxService} from "../../shared/glightbox/glightbox.service";
import {VWOService} from "../../shared/vwo/vwo.service";
import {CryptoForm2Component} from "../../shared/webflow/cryptoform2/cryptoform2.component";

declare var $: any;
declare var Accordion: any;
declare var GLightbox: any;

@Component({
    selector: 'landing1',
    templateUrl: './landing1.component.html',
    styleUrls: ['./landing1.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class Landing1Component implements AfterViewInit, OnDestroy {

  public email: string;
  public userInSession = null;

  protected subscriptions: Subscription[] = new Array<Subscription>();

  public howItWorksVisibleSection = 1;

  protected exchangePricesSubject = null;

  public imageBaseUrl: string;

  public exchangePrices = {};

  protected lightbox: any;

  public products = [];

  public showCryptoForm1 = true;
  public showCryptoHero1 = false;
  public showCryptoForm2 = false;

  protected carouselText = [
    {text: $localize`easy`},
    {text: $localize`secure`},
    {text: $localize`fast`}
  ]

  @ViewChild('selectCrypto') selectCrypto: SelectCrypto2Component;

  public highlightArticles = [];

  public cryptoform1Title = 1;

  @ViewChild('typedText') protected typedText: ElementRef;
  @ViewChild('containerDesktopPhone') protected containerDesktopPhone: ElementRef;
  @ViewChild('containerPhone') protected containerPhone: ElementRef;

  @ViewChild('cryptoform1') protected cryptoform1: CryptoForm1Component;
  @ViewChild('cryptoform2') protected cryptoform2: CryptoForm2Component;

  public constructor(protected accountService: AccountService,
                     protected flowService: FlowService,
                     protected productService: ProductService,
                     protected scrollService: ScrollService,
                     protected navigationService: NavigationService,
                     protected contentControllerService: ContentControllerService,
                     protected vwoService: VWOService,
                     protected cacheService: CacheService,
                     protected renderer: Renderer2,
                     protected title: Title,
                     protected gLightboxService: GlightboxService,
                     protected navbarService: NavbarService,
                     protected route: ActivatedRoute,
                     @Inject(DOCUMENT) private document: Document,
                     @Inject(ENVIRONMENT) protected environment: any,
                     @Inject(IS_BROWSER) protected isBrowser: boolean,
                     public purchaseFlowHelperService: PurchaseFlowHelperService,
                     public exchangeService: ExchangeService,
                     protected registrationService: RegistrationService) {

    this.title.setTitle($localize`AhoraCrypto - Buy Bitcoin, Ethereum and other cryptocurrencies in a simple, fast and secure way`);

    this.subscriptions.push(this.route.params.subscribe(params => {

      if (params.hasOwnProperty('copy')) {
        this.cryptoform1Title = params['copy'];
        //check that title is numeric
        if (isNaN(this.cryptoform1Title)) {
          this.cryptoform1Title = 1;
        }
        else if(this.cryptoform1Title == 5) {
          this.showCryptoForm1 = false;
          this.showCryptoHero1 = true;
          this.showCryptoForm2 = false;
        }
        else if(this.cryptoform1Title == 6) {
          this.showCryptoForm1 = false;
          this.showCryptoHero1 = false;
          this.showCryptoForm2 = true;
        }

      }
    }));

    this.imageBaseUrl = environment.apiBasePath;

    this.accountService.userSubject$.subscribe(user => {
      this.userInSession = user;
    });

    this.loadContent();

    this.subscriptions.push(this.exchangeService.exchangePricesSubject$.subscribe(exchangePrices => {
      this.updateCryptoInformation(exchangePrices);
    }));

    this.navbarService.setShowSections(true);
    if(this.cryptoform1Title == 6) {
      this.navbarService.setDarkMode(true);
      this.navbarService.setLogoDark(true);
    }
    else {
      this.navbarService.setDarkMode(true);
    }

    this.vwoService.load();

  }


  ngAfterViewInit(): void {

    if(this.showCryptoForm1) {
      this.cryptoform1.title = this.cryptoform1Title;
    }

    if(this.isBrowser) {

      this.carousel(this.carouselText, this.typedText);

      const accordionItems = [];
      for(let i = 1; i <= 6; i++) {
        let item = {
          id: 'home-accordion-open-heading-' + i,
          triggerEl: this.document.querySelector('#home-accordion-open-heading-' + i),
          targetEl: this.document.querySelector('#home-accordion-open-body-' + i),
          active: i == 1
        };
        accordionItems.push(item);
      }

      const options = {
        alwaysOpen: true,
        activeClasses: 'faq-active',
        inactiveClasses: 'faq-inactive',
        onOpen: (item) => {
          //todo
        },
        onClose: (item) => {
          //todo
        },
        onToggle: (item) => {
          //todo
        },
      };

      const accordion = new Accordion(accordionItems, options);

      setTimeout(() => {
        if ($(".section-how-it-works").length > 0) {
          let navigation_position_top = $(".section-how-it-works").offset().top;

          this.subscriptions.push(this.scrollService.scrollPositionY.subscribe(positionY => {

            if (positionY >= navigation_position_top - 500) {
              this.renderer.addClass(this.containerDesktopPhone.nativeElement, 'active');
              setTimeout(() => {
                this.renderer.addClass(this.containerPhone.nativeElement, 'active');
              }, 500);
            }

          }));
        }
      }, 1000);

      this.gLightboxService.load().then(result => {
        this.lightbox = GLightbox({
          'href': $localize`https://youtube.com/watch?v=Pb1hV2HtcxE`,
          'type': 'video',
          'source': 'youtube', //vimeo, youtube or local
          'width': 940,
          'height': 528,
          'thumbnailUrl': 'https://i.ytimg.com/vi/eSnGmr19Uo4/hqdefault.jpg',
          'autoplayVideos': true,
        });
      });

    } //end if isBrowser

    //top crypto to show
    this.productService.refreshProducts().then((products) => {
      this.exchangePricesSubject = this.exchangeService.exchangePricesSubject$.subscribe(exchangeRates => {
        if (exchangeRates != null && Object.keys(exchangeRates).length > 0) {
          //get winner currencies:
          let winnerCurrenciesSymbols = this.exchangeService.getExchangePricesOrderByWinners(this.purchaseFlowHelperService.selectedCurrency, 16)
            .map(exchangePrice => exchangePrice.baseCurrency);
          this.products = Object.values(products).filter(product => {
            return winnerCurrenciesSymbols.includes(product.id);
          });
          //set a timeout to ensure that exchangePriceSubject has the subscription to unsubscribe to
          setTimeout(() => {
            this.exchangePricesSubject.unsubscribe();
          });
        }
      });
    });
  }

  public ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  public loadContent() {
    if(this.cacheService.hasLatest3Articles()) {
      this.highlightArticles = this.cacheService.getLatest3Articles();
    }
    else {
      this.contentControllerService.contentControllerFindAll(1, 3).subscribe((contents) => {
        //add all articles to cache
        contents.pop(); //always remove last one!
        this.cacheService.setLatest3Articles(contents);
        this.highlightArticles = contents;
      });
    }
  }

  public showHowItWorksSection(sectionNumber) {
    this.howItWorksVisibleSection = sectionNumber;
  }

  protected async typeSentence(sentence, eleRef, delay = 100) {
    const letters = sentence.split("");
    let i = 0;
    while(i < letters.length) {
      await this.waitForMs(delay);
      eleRef.nativeElement.innerHTML += letters[i];
      i++;
    }
    return;
  }

  protected async deleteSentence(eleRef) {
    const sentence = eleRef.nativeElement.innerHTML;
    const letters = sentence.split("");
    let i = 0;
    while(letters.length > 0) {
      await this.waitForMs(100);
      letters.pop();
      eleRef.nativeElement.innerHTML = letters.join("");
    }
  }

  protected async carousel(carouselList, eleRef) {
    if(this.isBrowser) {
      let i = 0;
      while (true) {
        await this.typeSentence(carouselList[i].text, eleRef);
        await this.waitForMs(1500);
        await this.deleteSentence(eleRef);
        await this.waitForMs(500);
        i++
        if (i >= carouselList.length) {
          i = 0;
        }
      }
    }
  }

  protected waitForMs(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  protected updateCryptoInformation(exchangePrices) {
    this.exchangePrices = exchangePrices;
  }

  public buy() {
    this.selectCrypto.action = 'buy';
    this.scrollToTop();
  }

  public sell() {
    this.selectCrypto.action = 'sell';
    this.scrollToTop();
  }

  public scrollToTop() {
    $('html,body').animate({
      scrollTop: 0
    }, 'slow');
  }

}
